<!--
 * @Description: 路网态势感知平台
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-23 14:11:22
 -->
<template>
  <div class="roadNetworkSituationAwareness">
    <div class="left">
      <div class="left-top">
        <LeftTop />
      </div>
      <div class="left-bottom">
        <LeftBottom />
      </div>
    </div>
    <div class="middle">
      <div class="ChinaMap">
        <dv-flyline-chart-enhanced :dev="true" :config="mapConfig" style="width:100%;height:100%;" />
      </div>
      <div class="platFormIntroduceBtn" @click="detailShowSwitch">平台介绍</div>
      <transition name="el-zoom-in-center">
        <div class="platFormIntroduceDetail" v-if="showDetail">
          <span class="closeBtn el-icon-close" @click="closePdfView"></span>
          <iframe :src="pdfUrl + '#scrollbars=0&toolbar=0&statusbar=0'" frameborder="0" scrolling="no"></iframe>
        </div>
      </transition>
    </div>
    <div class="right">
      <div class="right-top">
        <RightTop />
      </div>
      <div class="right-middle">
        <RightMiddle />
      </div>
      <div class="right-bottom">
        <RightBottom />
      </div>
    </div>
  </div>
</template>

<script>
import LeftTop from './components/leftTop'
import LeftBottom from './components/leftBottom'
import RightTop from './components/rightTop'
import RightMiddle from './components/rightMiddle'
import RightBottom from './components/rightBottom'
export default {
  name: 'roadNetworkSituationAwareness',
  components: {
    LeftTop,
    LeftBottom,
    RightTop,
    RightMiddle,
    RightBottom,
  },
  data () {
    return {
      showDetail: false,
      pdfUrl: 'https://bigdata-v.prod.hndfsj.net/lwtsgz.pdf',
      mapConfig: {},
    }
  },
  methods: {
    /**
     * @description                   平台介绍详细信息的打开与隐藏
     * @return {undefied}             无返回值
     */
    detailShowSwitch () {
      this.showDetail = !this.showDetail
    },
    /**
     * @description                   关闭平台介绍
     * @return {undefied}             无返回值
     */
    closePdfView () {
      this.showDetail = false
    },
    /**
     * @description                   获取地图数据
     * @return {undefied}             无返回值
     */
    getDeployMapData () {
      this.$http.get('/rest/screen/project/list', {
        productCode: 'lwtsgz',
      }).then(res => {
        if (res.code === 0) {
          let points = [
            {
              name: '河南省',
              coordinate: [0.65, 0.45],
              icon: {
                src: '/static/img/layout/mapCenterPoint.png',
                width: 30,
                height: 30,
              },
              halo: {
                show: true,
              },
              text: {
                color: '#00ffee',
              },
            },
          ]
          let lines = []
          res.data.map(item => {
            if (item.provincePosition) {
              points.push({
                name: item.provinceName,
                coordinate: [parseFloat(item.provincePosition.split(',')[0]), parseFloat(item.provincePosition.split(',')[1])],
              })
              lines.push({
                radius: 60,
                width: 2,
                source: '河南省',
                target: item.provinceName,
              })
            }
          })
          this.mapConfig = {
            bgImgSrc: '/static/img/layout/map-China.png',
            points: points,
            lines: lines,
            icon: {
              show: true,
              src: '/static/img/layout/mapPoint.png',
            },
            text: {
              show: true,
            },
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getDeployMapData()
  },
}
</script>

<style lang="less" scoped>
  .roadNetworkSituationAwareness {
    width: 90%;
    height: calc(100% - 10vh);
    margin: 0 5%;
    padding: 5vh 0;
    display: flex;
    justify-content: space-between;
    >div {
      display: inline-block;
    }
    .left {
      width: 26%;
      height: 100%;
      .left-top {
        width: 100%;
        height: 43%;
      }
      .left-bottom {
        width: 100%;
        height: 47%;
      }
    }
    .middle {
      width: 44%;
      height: 100%;
      position: relative;
      .ChinaMap {
        width: 90%;
        aspect-ratio: 7.07/6.92;
        position: absolute;
        top: 3%;
        left: 5%;
      }
      .platFormIntroduceBtn {
        width: 17%;
        height: 8%;
        background: url('/static/img/layout/platformIntroduceBg.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 18%;
        left: 0;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 1.8vh;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
      }
      .platFormIntroduceDetail {
        width: 800px;
        height: 800px;
        padding-top: 30px;
        overflow-y: scroll;
        position: absolute;
        top: -50px;
        left: 130px;
        color: #d7fdff;
        font-size: 18px;
        line-height: 24px;
        z-index: 10000;
        .closeBtn {
          display: inline-blockl;
          width: 20px;
          height: 20px;
          cursor: pointer;
          font-size: 30px;
          position: absolute;
          right: 5px;
          top: 0;
          z-index: 10000000;
        }
        iframe {
          width: 100%;
          height: calc(100% - 20px);
          border-radius: 10px;
          ::-webkit-scrollbar-thumb {
            cursor: pointer;
            box-shadow: inset 0 0 6px #106669;
            background-color: #05dbe3;
            border-radius: 4px;
          }

          ::-webkit-scrollbar:hover {
            width: 5px;
            height: 10px;
          }

          ::-webkit-scrollbar-corner {
            background-color: #181f27;
          }
        }
      }
    }
    .right {
      width: 26%;
      height: 100%;
      .right-top {
        width: 100%;
        height: 20%;
      }
      .right-middle {
        width: 100%;
        height: 37%;
      }
      .right-bottom {
        width: 100%;
        height: 34%;
      }
    }
  }
</style>
